export const STATUS_ORDER = [
    "Draft",
    "Submitted",
    "Under Review",
    "Assessment", 
    "Estimate", 
    "Work Order",
    "On Hold",
    "Canceled",
    "Canceled by Customer",
    "Completed",
    "Closed"
  ];

export const STATUS_RULES = {
    "Draft": {
      canEdit: true,
      isCompleted: false,
      canDelete: true,
      canSubmit: true,
      nextStatuses: ["Submitted"],
      cannotGoBack: true
    },
    "Submitted": {
      canEdit: true,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: ["Under Review", "On Hold", "Canceled"],
      cannotGoBack: true
    },
    "Under Review": {
      canEdit: true,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: ["Assessment", "Estimate", "Work Order", "On Hold", "Canceled"],
      cannotGoBack: true
    },
    "Assessment": {
      canEdit: false,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: ["Completed", "Closed", "Canceled by Customer"],
      cannotGoBack: true
    },
    "Estimate": {
      canEdit: false,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: ["Completed", "Closed", "Canceled by Customer"],
      cannotGoBack: true
    },
    "Work Order": {
      canEdit: false,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: ["Completed", "Closed", "Canceled by Customer"],
      cannotGoBack: true
    },
    "On Hold": {
      canEdit: false,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: ["Under Review","Assessment", "Estimate", "Work Order", "Canceled"],
      cannotGoBack: true
    },
    "Canceled": {
      canEdit: false,
      isCompleted: true,
      canDelete: false,
      canSubmit: false,
      nextStatuses: [],
      cannotGoBack: true
    },
    "Canceled by Customer": {
      canEdit: false,
      isCompleted: true,
      canDelete: false,
      canSubmit: false,
      nextStatuses: [],
      cannotGoBack: true
    },
    "Completed": {
      canEdit: false,
      isCompleted: true,
      canDelete: false,
      canSubmit: false,
      nextStatuses: ["Closed"],
      cannotGoBack: true
    },
    "Closed": {
      canEdit: false,
      isCompleted: true,
      canDelete: false,
      canSubmit: false,
      nextStatuses: [],
      cannotGoBack: true
    }
  };

  
export const getStatusRules = (currentStatus) => {
return STATUS_RULES[currentStatus] || {};
};
  
// const currentStatus = "Under Review";
// const rules = getStatusRules(currentStatus);

// console.log("Can Edit:", rules.canEdit); // true
// console.log("Next Status Options:", rules.nextStatuses); // ["Assessment / Estimate / Work Order", "On Hold", "Canceled"]

export const canTransition = (currentStatus, nextStatus) => {
    const rules = getStatusRules(currentStatus);
    return rules.nextStatuses.includes(nextStatus);
  };
  
// const nextStatus = "Submitted";
// if (canTransition(currentStatus, nextStatus)) {
//   console.log("Transition allowed");
// } else {
//   console.log("Transition NOT allowed");
// }
